import React from "react";
import { MaskedReveal, FadeUp } from "@/components/motion/Reveal";

export const PEOPLE = [
  {
    name: "Adv. Prasad Helkar",
    role: "Founder & Managing Advocate",
    initials: "PH",
    image: "",
    bio: "Leads the firm's litigation and advisory practice, personally supervising every mandate across criminal, civil, corporate and family matters before the Sessions Court and Bombay High Court.",
  },
  {
    name: "Adv. Sushma Patil",
    role: "Co-Founder & Advocate",
    initials: "SP",
    image: "",
    bio: "Co-founder of Helkar & Associates, advising clients across the firm's core practice areas with a focus on diligence, discretion and client-first counsel.",
  },
];

export default function People({ chapter = "The People", className = "" }) {
  return (
    <section className={`py-20 md:py-28 ${className}`} data-testid="people">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="mono text-xs uppercase tracking-[0.32em] text-gold mb-6">{chapter}</div>
        <MaskedReveal as="h2" className="serif text-5xl md:text-6xl leading-[0.98]" lines={["The advocates", <>behind the <em className="italic text-gold">counsel.</em></>]} />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 mt-16">
          {PEOPLE.map((p, i) => (
            <FadeUp key={p.name} delay={i * 0.12} className="group">
              <div className="aspect-[4/5] hairline border overflow-hidden relative bg-navy">
                {p.image ? (
                  <img src={p.image} alt={p.name} className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105" loading="lazy" />
                ) : (
                  <div className="w-full h-full flex flex-col items-center justify-center text-ivory">
                    <span className="serif text-7xl md:text-8xl text-gold">{p.initials}</span>
                    <span className="mono text-[10px] uppercase tracking-[0.3em] mt-6 text-ivory/60">Portrait to follow</span>
                  </div>
                )}
              </div>
              <div className="mt-5 flex items-baseline justify-between">
                <h3 className="serif text-2xl md:text-3xl">{p.name}</h3>
                <span className="mono text-[10px] uppercase tracking-[0.28em] text-[hsl(var(--muted-foreground))]">{p.role}</span>
              </div>
              <p className="mt-3 text-[15px] leading-relaxed text-[hsl(var(--muted-foreground))] max-w-md">{p.bio}</p>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
